
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Toto prináša projekt
                    <a href="${0}">Folksonomy Engine</a>. Neváhajte
                    sa zapojiť alebo poskytnúť spätnú väzbu.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Tento nástroj vám umožňuje opraviť zoznam zložiek. Môžete pridať, odstrániť alebo upraviť
                zoznam zložiek.
                <br>
                Tento znak <span class="highlight">␣</span> predstavuje medzeru.
                <br>
                Tento znak <span class="highlight">↩︎</span> predstavuje zalomenie riadku. `,
'hb28f1f2ec1744ee9': html`Tieto vlastnosti vytvárajú a archivujú používatelia na akékoľvek účely. Neváhajte a pridajte si vlastné
                    . Vlastnosti a hodnoty, ktoré vytvoríte
                    <strong>, musia byť faktické</strong>. Môžete sa ponoriť do
                    <a href="${0}">zoznamu vlastností, ktoré už komunita používa</a>
                    alebo preskúmať dokumentáciu k vlastnostiam
                    <a href="${1}">a ich vyhľadávací nástroj</a>.`,
's000a5b76bd3a01c2': `Načítavajú sa vlastnosti...`,
's000d98595e959c1e': `Získať z obchodu Google Play`,
's013bdc8cf0d3583d': `Pomôžte nám s ingredienciami`,
's01d2865e3e1d5501': `Ďakujeme za vašu pomoc!`,
's02ce7a2e7c1b020b': `Overiť plodinu`,
's03e9c8114521b998': `Upravím ingrediencie`,
's05ec315d9308091a': `Ikona rohov čiarového kódu`,
's061eb5af92512c85': `Uložené! Viete pomôcť s ďalším?`,
's06847c221c4c0bc1': `Chcel by som vytvoriť vlastnosť na [popíšte svoj prípad použitia]...`,
's06f6c6f99db6b552': `Originál`,
's081e2ad82db71e1d': `Zoskupené hodnoty`,
's09205907b5b56cda': `Nie`,
's0b4235aae602a950': `špecializovaná dokumentácia`,
's0bb2d48532acc455': `Stiahnuť súbor CSV`,
's0d5b7fee0311db68': `Vlastnosť`,
's0fb218abc2e157ed': `Zrušiť platnosť obrázka`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Zrušiť orezanie`,
's11a18a69b30b65ed': `Pomôžte nám opraviť chyby v zozname zložiek`,
's1205d5f6fccf8e69': `Hodnota nehnuteľnosti`,
's15d64a0a6715285a': `Nový kľúč`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Oblasť výberu`,
's1a52515ec8ddade8': `Čiarový kód produktu`,
's1c5031113de500ce': `udržiavanie našej databázy otvorenej &amp; dostupnej pre všetkých,`,
's1dc4daf989c71284': `Pomôžte nám opraviť nutričné informácie`,
's1e00019dc454872d': `Zadajte názov vlastnosti pomocou atribútu property-name.`,
's1e49126af0935a5b': `Zoznam produktov používajúcich túto vlastnosť`,
's21e73088de6f26f3': `Stiahnite si na App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Ďakujeme za vašu pomoc! Môžete pomôcť s ďalšou otázkou?`,
's2ceb11be2290bb1b': `Zrušiť`,
's2db7b654c0a9bde0': `Zdokumentujte nehnuteľnosť`,
's300b3a6ee4e1252d': str`Slabá zhoda ${0}%`,
's33f786bb6b4f0cf4': `Výsledok orezania`,
's33f85f24c0f5f008': `Uložiť`,
's34be4af4e8fec4ae': `Najprv sa opýtajte komunity`,
's36d86adc823cbfa6': `Pred vytvorením novej nehnuteľnosti sa o nej porozprávajte s komunitou:`,
's3781d25aa51a736c': `Dokumentácia k nástroju Folksonomy`,
's383ae4449428b61e': `Obnoviť orezanie`,
's39bcf88721a1e8ee': `Obnoviť výber`,
's39e14e14300694c7': `Dokumentácia a pokyny`,
's3b430cfa5c1fe7f4': str`Dokumentácia pre ${0}`,
's3f4e4b52f230a892': `Obrazové plátno`,
's417b90913e05bc17': `Náhľad`,
's41f7dca46d3f1b4a': `Hodnota`,
's422bba9636ce2489': `Vycentrovať obrázok`,
's42dd66b2441566fd': `Ikona stredu`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Pridajte živinu`,
's453ab0dbb9b5c777': `Zmeniť veľkosť vpravo`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Načítava sa...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Počet produktov`,
's4df2f533c0c1e7d0': `Ovládacie prvky obrázka`,
's4e94adf723979402': `Open Food Facts potrebuje vašu pomoc s týmto produktom.`,
's4f4886341969d552': `Presunúť výber`,
's4f751fb9b3ed766c': `Vytvorenie novej nehnuteľnosti`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Zadajte názov nehnuteľnosti...`,
's55d7249883a98ca1': `o tejto nehnuteľnosti na wiki Open Food Facts`,
's565867d84c04aea2': `Filtrovať vlastnosti...`,
's5666afe5cd0166de': `Pred potvrdením opravte chyby alebo upravte text`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Načítavajú sa produkty...`,
's59df20feee978e5b': `Chyba: Neplatná hodnota.`,
's5c92c0051d44b6de': `Pomôžte nám opraviť nutričné informácie.`,
's5dd6f12783fca34f': `Upraviť zoznam ingrediencií`,
's5e8250fb85d64c23': `Zatvoriť`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `jednotka`,
's64ef2a6c2dd1d3d1': `Upraviť`,
's66413c24dcf680e2': `Preskočiť`,
's67ae6594857a4d57': `Ďakujeme za Váš príspevok!`,
's6cee7cad81dfedd1': `Orezaný obrázok`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Dobrá zhoda ${0}%`,
's71a5c9f4b68ef4d4': `Počet`,
's74cb3d66f6a668e1': `Dokumentácia`,
's787dd11bed0dc88a': `Zmeniť veľkosť doľava`,
's7ce4fd9430e80cea': `hodnota`,
's801a05fa8e881f37': `Získajte viac informácií o vytváraní nehnuteľností a pokynoch:`,
's8038273de2cf8b73': `Vyberte oblasť, ktorú chcete orezať.`,
's839cc2908a5387f2': `Filtrovať čiarové kódy...`,
's86197dcf3e96af64': `Prehliadajte a vyhľadávajte existujúce nehnuteľnosti`,
's8a63be30a129a59c': `Zmeniť veľkosť dolnej časti`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Zmeniť veľkosť vpravo hore`,
's8db84aa4bc949af2': `Zdokumentujte novú nehnuteľnosť`,
's8f839a03997a16d7': `Zobraziť produkt`,
's901ae1e236ac45d3': `Zrušiť odstránenie`,
's907f7a97c6b29425': `Upozorňujeme, že dátový model môže byť upravený. Používajte na vlastné riziko.`,
's95d23d03f9147581': `Zrušiť priblíženie`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Zloženie:`,
's9a7f60fce090ecaf': `Nepodarilo sa načítať vlastnosti. Skúste to znova neskôr.`,
's9b87abd68fb9df45': `Nenašli ste? Vytvorte nový kľúč {value}`,
's9c0f52425fd2f07e': `Nemusí sa zhodovať`,
's9fc41f789c63b40d': `Výrobky`,
'sa1fa766e0d5634d7': `Žiadne skóre k dispozícii`,
'sa548778b24054030': `Preskúmajte všetky prispievajúce vlastnosti z projektu Folksonomy Engine. Tieto vlastnosti poskytujú ďalšie metadáta a informácie o produktoch v databáze Open Food Facts.`,
'sa63907958bd0ec4b': `Zmeniť veľkosť vľavo hore`,
'sa95b4224f685a36a': `Zatvoriť modálne okno`,
'sab56a1d439576fd6': `Ikona návrhu`,
'sac47ea2901d04c15': `Zmeniť veľkosť vľavo dole`,
'sb125227d436c2925': `Vyhľadajte si koncept nehnuteľnosti v existujúcej databáze nehnuteľností:`,
'sb125568d43642e6f': `Odpovedzte na otázky týkajúce sa produktu.`,
'sb1c538e038f9b214': str`Veľmi dobrá zhoda ${0}%`,
'sb28639570ff3b852': `zoznam všetkých nehnuteľností`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Keď overíte, že vaša nehnuteľnosť neexistuje a komunita súhlasí s jej užitočnosťou, musíte ju najprv zdokumentovať na wiki.`,
'sb3d4f79d9d8b71e5': `Potvrdiť`,
'sb560fa37a7bfb6c2': `Pre túto nehnuteľnosť sa nenašli žiadne produkty.`,
'sb7f72e4c8a2d3357': `Filtrovať hodnoty...`,
'sb8178320160f84ea': `Zobraziť orezanie`,
'sbad7d2734149470b': `Potvrdiť`,
'sbb623d6b18d966a0': `Výživové údaje sú uvedené na obale:`,
'sbd6be5cde472f37c': `Všetky postrehy boli zodpovedané! Ďakujem za vašu pomoc!`,
'sbd9a0b2293b3cd3c': `Veľkosť porcie`,
'sbe472dc3c2685985': `Zodpovedajúca hodnota`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Zmeniť veľkosť hornej časti`,
'sc1c08d0cbcc3bd24': `Nezhoduje sa`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Otočte obrázok doľava`,
'sc57b630a7a70c61f': `Navrhovaná oprava`,
'sc681b137e8f604f7': `Potvrdiť vymazanie`,
'sc6daf8a31883f8b9': `Presunúť obrázok`,
'sc895972c88d38ca5': `Majetok Folksonomy`,
'sca0c3305aff570b8': str`na uvedenú porciu "${0}"`,
'scace072bef961918': `Riadky`,
'scb3b0671d7b7f640': `Nová hodnota`,
'scb489a1a173ac3f0': `Áno`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Pripojte sa k diskusii na Slacku`,
'scdb6cad0b92721bf': `Neboli nájdené žiadne nehnuteľnosti.`,
'scf23a05631f93732': `Potvrdiť odstránenie`,
'scfed2f270ef6a3aa': `Vyberte oblasť`,
'sd1022bc1ef9204f7': `Zväčšiteľný obrázok`,
'sd1077c055cf9ba6b': `Pomôžte nám overiť zoznam zložiek produktu.`,
'sd698d21ddecba56b': `Ahoj! Môžeš nám pomôcť vylepšiť informácie o produkte zodpovedaním nasledujúcich otázok:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Skontrolujte, či už nehnuteľnosť existuje`,
'sdbf806fefc584115': `Mali by ste nájsť`,
'sdc673e73b5c13aea': `Vymazať`,
'sdc792b75f1edcaba': `Pomôžte nám opraviť pravopis zložiek.`,
'sdca5deead576ceee': `Zmeniť veľkosť vpravo dole`,
'sdcc2555c5dde524f': `Naozaj chcete túto položku odstrániť? Túto akciu nie je možné vrátiť späť.`,
'se206feec7ec57b28': `na 100 g`,
'se419a9ab36987490': `Zrušiť platnosť`,
'se5127cf0f92e7e48': `Tip: nájdete aj`,
'se773f50d2a16d481': `Otočte obrázok doprava`,
'sebb2c6c830a44574': `technická infraštruktúra (webová stránka/mobilná aplikácia) &amp; malý stály tím`,
'sec6377f3c4e9b28c': `Navrhnem lepšiu úrodu`,
'seea3800e27baa686': `Jednotlivé produkty`,
'sefaba4adc4ec9219': `Vlastnosti Folksonomy`,
'seffa8ca49175b5f0': `Personalizované vlastnosti`,
'sf44a6b3b232c28ea': str`Nahraďte aktuálnu hodnotu hodnotou ${0}`,
'sf4cd86a2f5ef2588': `Čiarový kód produktu`,
'sf57a61152168cc81': `Pomôžte nám opraviť detekciu zložiek`,
'sf88b90b8ba23871c': `Neznáma zhoda`,
'sf9aee319a006c9b4': `Pridať`,
'sfacbbe968fa7d773': `Názov nehnuteľnosti:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Zodpovedajúca hodnota`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  